import * as React from "react";
import { useState, useMemo } from "react";
import styled from "styled-components";
import { isPermitted } from "util/PermissionsMixin";
import useCurrentUser from "hooks/useCurrentUser";
import BootstrapModalConfirm from "components/bootstrap/BootstrapModalConfirm";
import { Button, Label } from "components/bootstrap";
import { Icon } from "components/common";
import { DataWell } from "common/components";
import Routes from "routing/Routes";
import { useRemoveEvidence } from "security-app/hooks/useInvestigationsAPI";
import useHistory from "routing/useHistory";
import EvidenceSectionHeader from "security-app/components/Investigations/Details/OverviewSegment/EvidenceSectionHeader";
import useGoToEvidencePage from "./useGoToEvidencePage";
import { IconButton, StyledLink } from "../styled.components";
const DashboardEvidenceList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding-right: 1rem;
`;
const StyledIconButton = styled(IconButton)`
  padding: 0;
`;
const StyledLabel = styled(Label)`
  display: flex;
  flex-direction: row;
  height: 24px;
  gap: 0.4rem;
`;
function Dashboards({ investigation, isExpanded, onToggleExpanded }) {
  const { permissions } = useCurrentUser();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteDashboardId, setDeleteDashboardId] = useState(null);
  const history = useHistory();
  const goToDashboards = useGoToEvidencePage(investigation.id, Routes.DASHBOARDS);
  const canManageEvidence = useMemo(
    () => !investigation.archived && isPermitted(permissions, "investigations:edit"),
    [investigation.archived, permissions]
  );
  const { removeEvidence, removingEvidence } = useRemoveEvidence();
  const removeDashboard = async () => {
    await removeEvidence({ invId: investigation.id, payload: { dashboards: [deleteDashboardId] } });
    setShowDeleteDialog(false);
    setDeleteDashboardId(null);
  };
  const onDelete = (dashboardId) => (e) => {
    e.stopPropagation();
    setShowDeleteDialog(true);
    setDeleteDashboardId(dashboardId);
  };
  const onCancelDelete = () => {
    setShowDeleteDialog(false);
    setDeleteDashboardId(null);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DataWell, { $color: "content" }, /* @__PURE__ */ React.createElement(
    EvidenceSectionHeader,
    {
      sectionName: "dashboards",
      title: "Dashboards",
      count: investigation.dashboards.length,
      isExpanded,
      onToggleExpanded,
      action: canManageEvidence ? /* @__PURE__ */ React.createElement(Button, { onClick: goToDashboards }, "Go to Dashboards") : null
    }
  ), isExpanded && /* @__PURE__ */ React.createElement("div", { style: { marginTop: "0.5rem" } }, investigation.dashboards.length === 0 ? /* @__PURE__ */ React.createElement("div", { style: { color: "gray" } }, "There are no dashboards to list") : /* @__PURE__ */ React.createElement(DashboardEvidenceList, null, investigation.dashboards.map((dashboard) => /* @__PURE__ */ React.createElement(StyledLabel, { key: dashboard.id }, /* @__PURE__ */ React.createElement(StyledLink, { onClick: () => history.push(Routes.VIEWS.VIEWID(dashboard.id)) }, dashboard.title), canManageEvidence && /* @__PURE__ */ React.createElement(
    StyledIconButton,
    {
      $danger: true,
      "aria-label": `Delete dashboard ${dashboard.title}`,
      onClick: onDelete(dashboard.id)
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "close" })
  )))))), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: showDeleteDialog,
      title: "Delete Dashboard",
      onConfirm: removeDashboard,
      onCancel: onCancelDelete,
      confirmButtonDisabled: removingEvidence
    },
    "Are you sure you want to delete this Dashboard?"
  ));
}
export default Dashboards;
